import {Component, Input} from "@angular/core";
declare let $:any;

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})

export class AlertComponent {
  @Input('AlertBgcolor') AlertBgcolor:string="#ff0000";
  @Input('AlertColor') AlertColor:string="#FFF";
  @Input('AlertText') AlertText:string="Alert";
  @Input('') type: string = 'success'; 

  public alertClosed:boolean=true;

  ngOnInit(){
    let self = this;
    setTimeout(function(){self.alertClosed = false;},500);
  }

  close(){
    this.alertClosed=true;
  }
}
